var App = App || {};

App.SharedFormValidation = (function ($) {
    'use strict';

    function Init(form) {
        Load(form);
        Submit(form)
    }

    function Load(form) {
        form.find("[data-zag-validate-input]").on("input", function () { Input($(this)); });
    }

    function Submit(form) {

        // remove kentico's update and onsubmit functions
        var kenticoSubmit = form.attr("onsubmit") || "",
            kenticoUpdate = form.attr("data-ktc-ajax-update") || "";

        form.removeAttr("onsubmit data-ktc-ajax-update").on("submit", function (e) {

            e.preventDefault();
            form.attr("data-zag-validate-form", "submitted");

            // different validation tactics
            form.find("[data-zag-validate-input]").each(function () { Input($(this)); });

            // if there are no error messages, submit the form
            if (form.find("[data-zag-validate-field=\"error\"]").length > 0) {
                form.find("[data-zag-validate-field=\"error\"]")
                    .first()
                    .find("[data-zag-validate-input]")
                    .first()
                    .trigger("focus");
            }
            else {
                if (kenticoSubmit !== "" && kenticoUpdate !== "") {
                    //replace kentico's onsubmit, etc. function from attribute list
                    $(this).attr({ "onsubmit": kenticoSubmit, "data-ktc-ajax-update": kenticoUpdate });
                    // and allow it to submit
                    $(this).off("submit").submit().find("input[type='submit']").prop("disabled", "true");

                    // The user may have had to scroll through the form to fill it out. If so, they may not see the top of the form any longer, which
                    // means they also won't see the "thank you" note to indicate their submission was successful. Scroll up so they see it.
                    $("html, body").animate({
                        scrollTop: $(this).offset().top - 65
                    }, 300);
                }
                // if there is no onsubmit, etc. function from attribute list maybe this isn't a Kentico form so submit it
                else {
                    $(this).off("submit").submit();
                }
            }
        });
    }

    function Input(input) {

        const field = input.parents("[data-zag-validate-field]");
        const errors = field.find("[data-zag-validate-errors]").show();

        // error handling for each input type and error type
        const errorRequired = field.find(`[data-zag-validate-error=\"required\"]`);
        if (input.attr("data-zag-validate-input") == "text") {
            input.val() !== "" ? errorRequired.hide() : errorRequired.show();
        }
        else if (input.attr("data-zag-validate-input") == "check") {
            field.find("input[data-zag-validate-input=\"check\"]:checked").length !== 0 ? errorRequired.hide() : errorRequired.show();
        }
        else if (input.attr("data-zag-validate-input") == "upload") {
            input.val() !== "" ? errorRequired.hide() : errorRequired.show();
        }
        else if (input.attr("data-zag-validate-input") == "recaptcha") {
            var recaptchaResponse = field.find(".g-recaptcha-response").val();
            recaptchaResponse != "" ? errorRequired.hide() : errorRequired.show();
        }

        const errorCount = errors.children("[data-zag-validate-error]:visible").length;
        if (errorCount > 0) {
            field.attr("data-zag-validate-field", "error");
            errors.show();
        }
        else {
            field.attr("data-zag-validate-field", "");
            errors.hide();
        }
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    $(".widget-rich-text-form form").each(function () {
        const form = this;

        if (!form.querySelector(".g-recaptcha")) return;

        const submitButton = form.querySelector('input[type="submit"]');

        if (!submitButton) return;

        function IsRecaptchaComplete() {
            const response = form.querySelector(
                '[name="g-recaptcha-response"]'
            );

            return response && response.value.trim() !== "";
        }

        function UpdateSubmitButton() {
            submitButton.disabled = !IsRecaptchaComplete();
        }

        UpdateSubmitButton();
        setInterval(UpdateSubmitButton, 500);

        form.addEventListener("submit", function (event) {
            if (!IsRecaptchaComplete()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                alert("Please complete the reCAPTCHA before submitting.");
            }
        }, true);
    });
});